"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _UISlider = _interopRequireDefault(require("UIComponents/input/UISlider"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _PriceDisplay = _interopRequireDefault(require("./pricing/PriceDisplay"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UINumberInput = _interopRequireDefault(require("UIComponents/input/UINumberInput"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _ContactsSelectors = require("pricing-pages-unified-ui/selectors/ContactsSelectors");

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _Editions = require("self-service-api/constants/Editions");

var _ContactsInfoBox = _interopRequireDefault(require("./info-box/ContactsInfoBox"));

var _ContactsMaxLimitContainer = _interopRequireDefault(require("./info-box/ContactsMaxLimitContainer"));

var _ContactsSelectors2 = require("../../selectors/ContactsSelectors");

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var _ContactPriceBreakdownModal = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/contacts-price-breakdown/ContactPriceBreakdownModal"));

var _PricingSelectors2 = require("pricing-pages-unified-ui/selectors/PricingSelectors");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n  width: 90px !important;\n  height: 30px !important;\n  font-size: 14px !important;\n  text-align: right !important;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-weight: bold;\n  display: inline-block;\n  margin: 0 16px 10px 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  flex: 1;\n  &:nth-child(2) {\n    text-align: right;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SliderLabel = (0, _styledComponents.default)(_Small.default).withConfig({
  displayName: "ContactsPicker__SliderLabel",
  componentId: "sc-13mkc97-0"
})(_templateObject());

var SliderTitle = _styledComponents.default.h5.withConfig({
  displayName: "ContactsPicker__SliderTitle",
  componentId: "sc-13mkc97-1"
})(_templateObject2());

var SliderInput = (0, _styledComponents.default)(_UINumberInput.default).withConfig({
  displayName: "ContactsPicker__SliderInput",
  componentId: "sc-13mkc97-2"
})(_templateObject3());

function ContactsPicker(_ref) {
  var additionalUnitQuantity = _ref.additionalUnitQuantity,
      onChange = _ref.onChange,
      merchandiseId = _ref.merchandiseId,
      term = _ref.term,
      products = _ref.products,
      minPurchasableContacts = _ref.minPurchasableContacts,
      moreDetailsGAClassName = _ref.moreDetailsGAClassName,
      setActiveEdition = _ref.setActiveEdition,
      _ref$isGrowthSuite = _ref.isGrowthSuite,
      isGrowthSuite = _ref$isGrowthSuite === void 0 ? false : _ref$isGrowthSuite,
      _ref$isCovidPromo = _ref.isCovidPromo,
      isCovidPromo = _ref$isCovidPromo === void 0 ? false : _ref$isCovidPromo,
      _ref$contactsQuantity = _ref.contactsQuantityMultiplier,
      contactsQuantityMultiplier = _ref$contactsQuantity === void 0 ? 1000 : _ref$contactsQuantity;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      modalVisible = _useState2[0],
      setModalVisible = _useState2[1];

  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  var merchData = products[merchandiseId];
  var step = contactsQuantityMultiplier;
  var edition = merchData.edition,
      merchMax = merchData.maxAdditionalUnits,
      includedUnits = merchData.includedAdditionalUnits,
      baseMerchId = merchData.id;
  var sliderMax = Math.max(minPurchasableContacts, merchMax);
  (0, _react.useEffect)(function () {
    var minPurchasableAdditionalContacts = minPurchasableContacts - includedUnits;

    if (additionalUnitQuantity < minPurchasableAdditionalContacts) {
      onChange(minPurchasableAdditionalContacts);
    } else if (additionalUnitQuantity > sliderMax - includedUnits) {
      onChange(sliderMax - includedUnits);
    }
  }, [minPurchasableContacts, additionalUnitQuantity]);
  var numContacts = includedUnits + additionalUnitQuantity;
  var getAdditionalContactsMonthlyCost = (0, _reactRedux.useSelector)(_PricingSelectors.getAdditionalContactsMonthlyCostSelector);
  var additionalUnitPrice = getAdditionalContactsMonthlyCost(merchandiseId, term, isGrowthSuite, isCovidPromo);

  var roundInput = function roundInput(_ref2) {
    var value = _ref2.target.value;
    var roundedValue = Math.round(value / step) * step;
    if (roundedValue < minPurchasableContacts) return;
    if (roundedValue > sliderMax) return;
    onChange(roundedValue - includedUnits);
  };

  var isMarketingStarter = merchandiseId === _MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL || merchandiseId === _MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019;
  var termId = (0, _reactRedux.useSelector)(_PricingSelectors2.getTermIdSelector)(baseMerchId, term, isGrowthSuite, isCovidPromo);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(SliderTitle, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.calculator.contacts.title"
  })), _react.default.createElement(_UIFlex.default, {
    direction: "row",
    justify: "between",
    align: "center",
    className: "m-bottom-6"
  }, _react.default.createElement(_Small.default, {
    className: 'm-right-2'
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage.calculator.contacts.additionalContactsSubtext." + edition + "_jsx",
    options: {
      price: additionalUnitPrice,
      currencyCode: currencyCode
    },
    elements: {
      PriceDisplay: _PriceDisplay.default,
      FormattedNumber: _FormattedNumber.default
    }
  }), isMarketingStarter && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_UILink.default, {
    onClick: function onClick() {
      setModalVisible(true);
      (0, _getUsageTracker.default)().track('clickToViewModal', {
        name: 'contact-pricing-details-modal'
      });
    },
    className: "text-right m-left-1 " + (0, _publicPageUrls.getGAClassName)(moreDetailsGAClassName),
    style: {
      whiteSpace: 'nowrap'
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    className: (0, _publicPageUrls.getGAClassName)(moreDetailsGAClassName),
    message: "pricingPage.calculator.moreDetails"
  })))), _react.default.createElement(SliderInput, {
    value: numContacts,
    onChange: roundInput,
    min: minPurchasableContacts,
    max: sliderMax,
    "data-selenium-id": "contacts-picker-input"
  })), _react.default.createElement(_UISlider.default, {
    className: "m-y-4",
    size: "large",
    step: step,
    trackStart: includedUnits,
    min: minPurchasableContacts,
    max: sliderMax,
    value: numContacts,
    onChange: roundInput
  }), _react.default.createElement(_UIFlex.default, null, _react.default.createElement(SliderLabel, null, _react.default.createElement(_FormattedNumber.default, {
    value: includedUnits
  })), _react.default.createElement(SliderLabel, null, _react.default.createElement(_FormattedNumber.default, {
    value: sliderMax
  }))), // Use info box only when setActiveEdition is defined. Should be used when upgrading
  // from marketing pro to enterprise is a better deal (e.g. marketing tab, bundles page)
  setActiveEdition && merchandiseId === _MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL && _react.default.createElement(_ContactsInfoBox.default, {
    titleKey: "pricingPage.calculator.contacts.pricingTip.title",
    content: _react.default.createElement(_FormattedJSXMessage.default, {
      message: "pricingPage.calculator.contacts.pricingTip.marketingProTip_jsx",
      elements: {
        UILink: _UILink.default
      },
      options: {
        onClick: function onClick() {
          return setActiveEdition(_Editions.ENTERPRISE);
        }
      }
    }),
    showBox: numContacts >= merchMax
  }), merchandiseId === _MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE && _react.default.createElement(_ContactsInfoBox.default, {
    titleKey: "pricingPage.calculator.contacts.upperLimitTip.title",
    content: _react.default.createElement(_ContactsMaxLimitContainer.default, null),
    showBox: numContacts === sliderMax
  }), modalVisible && _react.default.createElement(_ContactPriceBreakdownModal.default, {
    merchandiseId: products[merchandiseId].additionalUnitMerchId,
    handleModalClose: function handleModalClose() {
      return setModalVisible(false);
    },
    termId: termId
  }));
}

var mapStateToProps = function mapStateToProps(state, _ref3) {
  var merchandiseId = _ref3.merchandiseId;
  return {
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state),
    minPurchasableContacts: (0, _ContactsSelectors.minPurchasableContactsSelector)(state, merchandiseId),
    contactsQuantityMultiplier: (0, _ContactsSelectors2.contactsQuantityMultiplierSelector)(state, merchandiseId)
  };
};

ContactsPicker.defaultProps = {
  // a bit hacky, but to get around how this is abstracted right now
  moreDetailsGAClassName: 'marketing-pricing-startercontacts'
};
ContactsPicker.propTypes = {
  products: _propTypes.default.object.isRequired,
  additionalUnitQuantity: _propTypes.default.number,
  onChange: _propTypes.default.func.isRequired,
  merchandiseId: _propTypes.default.number.isRequired,
  term: _propTypes.default.string.isRequired,
  minPurchasableContacts: _propTypes.default.number.isRequired,
  moreDetailsGAClassName: _propTypes.default.string.isRequired,
  setActiveEdition: _propTypes.default.func,
  isGrowthSuite: _propTypes.default.bool,
  isCovidPromo: _propTypes.default.bool,
  contactsQuantityMultiplier: _propTypes.default.number
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(ContactsPicker);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/ContactsPicker.js
// module id = 283
// module chunks = 5 6